export function FormatDate(date, formatString) {
  // Local variable declaration
  let currentChar = '';
  let nextChar = '';
  let pattern = '';
  // Looping over the format string to search for pattern and replace the pattern with appropriate value.
  for (let i = 0; i < formatString.length; i += 1) {
    currentChar = formatString.charAt(i);
    nextChar = formatString.charAt(i + 1);
    pattern += currentChar;
    if (currentChar !== nextChar) {
      formatString = replacePattern(formatString, pattern, date);
      pattern = '';
    }
  }
  return formatString;
}

function replacePattern(formatString, pattern, date) {
  // Array for short month names.
  const shortMonthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  // Array for long month names.
  const longMonthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];

  switch (pattern) {
    case 'd':
      formatString = formatString.replace(pattern, date.getDate());
      break;
    case 'dd': {
      let dateStr = date.getDate();
      dateStr = `${dateStr}`;
      dateStr = dateStr.length < 2 ? padToLeft('0', 1, dateStr) : dateStr;
      formatString = formatString.replace(pattern, dateStr);
      break;
    }
    case 'M':
      formatString = formatString.replace(pattern, (date.getMonth() + 1));
      break;
    case 'MM': {
      let monthStr = (date.getMonth() + 1);
      monthStr = `${monthStr}`;
      monthStr = monthStr.length < 2 ? padToLeft('0', 1, monthStr) : monthStr;
      formatString = formatString.replace(pattern, monthStr);
      break;
    }
    case 'MMM':
      formatString = formatString.replace(pattern, shortMonthNames[date.getMonth()]);
      break;
    case 'MMMM':
      formatString = formatString.replace(pattern, longMonthNames[date.getMonth()]);
      break;
    case 'yy':
      formatString = formatString.replace(pattern, (`${date.getFullYear()}`).slice(-2));
      break;
    case 'yyyy':
      formatString = formatString.replace(pattern, date.getFullYear());
      break;
    default:
  }
  return formatString;
}

function padToLeft(padChar, padCount, targetString) {
  let padStr = '';
  for (let i = 0; i < padCount; i += 1) {
    padStr += padChar;
  }
  return (padStr + targetString);
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/Date/Date.js